<elder-basic-pane-layout class="full">
  <elder-pane>
    <elder-pane-content>
      @if (utilisationCtx$ | async; as utilisationCtx) {
        <div class="flex layout-col">
          <div class="layout-col place-center-stretch my-xl">
            @if (utilisationCtx?.wcUtil?.capacity === 'PT0S') {
              <div class="layout-row place-start-center gap-sm">
                <mat-icon [color]="utilisationCtx.wcUtil.capacityUsage > 0.0 ? 'warn' : 'primary'">
                  {{ utilisationCtx.wcUtil.capacityUsage > 0.0 ? 'warning' : 'info' }}
                </mat-icon>
                <span class="mat-caption">{{ 'context.unavailable' | translate }}</span>
              </div>
            } @else {
              <app-utilisation-capacity-bar
                [workCenterUtilisation]="utilisationCtx.wcUtil"
                [barThickness]="20"
                [showLegend]="true"
              >
              </app-utilisation-capacity-bar>
            }
          </div>
          @if (utilisationCtx.wcUtil) {
            <app-work-center-orders
              class="flex"
              [orders]="utilisationCtx.wcUtil.orders ?? []"
              (openRequested)="showOrderDetail($event)"
            >
            </app-work-center-orders>
          }
        </div>
      }
    </elder-pane-content>
  </elder-pane>

  <app-work-center-order-detail
    class="flex-50"
    [workCenterId]="(workCenter$ | async)?.id"
    [workOrderId]="activeOrderId$ | async"
    [itemConstraints]="itemConstraints$ | async"
    (contextRefreshRequest)="onContextRefreshRequest()"
  ></app-work-center-order-detail>
</elder-basic-pane-layout>
